export const ru = {
    'amnesty-price': 'Списываемая цена',
    bid: 'Ставка',
    'bid-forecast': 'Прогноз трафика',
    'low-shows-warning': 'С текущей ставкой ожидается мало показов на поиске.'
};
